import { useEffect, useState } from "react";
import {
  faFile,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Container } from "react-bootstrap";
import {
  DeleteRequest,
} from "../../Utils/hooks/ApiHandler";
import useLocalStorageState from "use-local-storage-state";
import { useGetRequest } from "../../Utils/hooks/QueryHandler";
import DeleteModal from "../DeleteModal";
import { toast } from "sonner";
import "./InvoiceOrder.css";
import { formatDate, formatToINR } from "../../Utils/helpers/commonhelper";
import { AuthorizationCard } from "../../CommonComponents/AuthorizationCard";
import { baseURL } from "../../Utils/constants/constant";
import { ColumnConfigurator } from "../../CommonComponents/ColumnConfigurator";
import { UpgradePlan } from "../../CommonComponents/UpgradePlan";
import { TableWrapper } from "../../CommonComponents/TableWrapper";
import { useGetEssentials } from "../../Utils/hooks/useGetEssentials";

export const PaymentReceviedOrder = () => {

  const { headers, extras, customerId: customer_id, loginUserId } = useGetEssentials();

  const [PERMISSION] = useLocalStorageState('permission');

  const [allSalesOrder, setAllSalesOrder] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const [limit, setLimit] = useState(5);
  const [offset, setOffset] = useState(0);
  const [search, setSearch] = useState("");
  const [inputSearch, setInputSearch] = useState("");

  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      setSearch(inputSearch.trim());
      setOffset(0);
    }, 300);
    return () => clearTimeout(debounceTimer);
  }, [inputSearch]);

  const params = {
    limit,
    offset,
    search: search,
  };

  const paymentGrant = PERMISSION.payment;
  const isPaymentReceived = paymentGrant?.isAuthorized;
  const isPaymentDelete = paymentGrant?.isDelete;

  const {
    data: salesOrderData,
    error,
    refetch: fetchSalesOrder,
    isLoading,
    isError,
  } = useGetRequest(
    `/invoice/fetchPayments/${customer_id}/${loginUserId}`,
    "getInvoiceOrder",
    headers,
    extras,
    params
  );

  useEffect(() => {
    fetchSalesOrder();
    setAllSalesOrder([]);

    if (salesOrderData?.status === "success") {
      setAllSalesOrder(salesOrderData.data);
    } else if (salesOrderData?.status === "fail") {
      setAllSalesOrder([]);
    } else if (isError) {
      console.error("Error fetching quotation:", error);
    }
  }, [salesOrderData]);

  const pageCount = Math.ceil(salesOrderData?.total_count / limit) || 0;
  const totalItems = salesOrderData?.total_count || 0;

  const currPageItems = salesOrderData?.length;

  const displayStartItem = totalItems === 0
    ? 0
    : offset * limit + 1;

  const displayEndItem = totalItems === 0
    ? 0
    : Math.min(offset * limit + limit, totalItems);

  const [paymentToDelete, setPaymentToDelete] = useState(null);

  const handlePageChange = (selectedItem) => {
    setOffset(selectedItem.selected);
  };

  const onDelete = (id) => {
    if (!isPaymentDelete) {
      return toast.error("You are not authorized to delete payment");
    }
    setPaymentToDelete(id);
    setShowDeleteModal(true);
  };

  const handleConfirmedDelete = async () => {
    try {
      const item = allSalesOrder.find((d) => d.payment_id === paymentToDelete);
      if (!item) return;
      setLoading(true);

      const res = await DeleteRequest(
        `invoice/deletePayment/${paymentToDelete}/${loginUserId}/${customer_id}`,
        { headers },
        extras,
      );

      if (res?.status === "success") {
        toast.success(res.message);
        setAllSalesOrder([]);
        await fetchSalesOrder();
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      console.error("Delete error:", error);
    } finally {
      setLoading(false);
      setShowDeleteModal(false);
      setPaymentToDelete(null);
    }
  };

  const columnOptions = [
    { key: "payment_number", label: "Payment Number", },
    { key: "invoice_number", label: "Invoice Number" },
    { key: "reference_number", label: "Reference Number" },
    { key: "account_type", label: "Account Type" },
    { key: "payment_mode", label: "Payment Mode" },
    { key: "amount_recieved", label: "Amount Received" },
    { key: "bank_charges", label: "Bank Charges" },
    { key: "payment_date", label: "Payment Date" },
    { key: "payment_recevied_on", label: "Payment Received On" },
    { key: "amount_deducted", label: "Amount Deducted" },
    { key: "tax_deducted", label: "Tax Deducted" },
    { key: "tds_tax_account", label: "TDS Tax Account" },
  ];

  const [columns, setColumns] = useState(() => {
    const saved = localStorage.getItem("visiblePayReceivedColumns");
    const allColumnKeys = columnOptions.map(col => col.label);
    if (saved) {
      try {
        return JSON.parse(saved);
      } catch (e) {
        console.error("Error parsing visible columns:", e);
      }
    }
    return allColumnKeys;
  });

  if (!isPaymentReceived) {
    return <UpgradePlan moduleName="Payment Received" />;
  }

  if (!paymentGrant?.isView) {
    return <div style={{ position: "absolute", left: "40%", top: "10rem" }}>
      <AuthorizationCard />
    </div>;
  }

  const tableHeader = () => (<thead style={{ zIndex: 101 }}>
    <tr>
      <th
        className="text-start  pinned-column last-pinned-column  bulk-selection-cell customize-cell-width"
        style={{
          width: 60,
          minWidth: 60,
          maxWidth: 60,
          left: 0,
        }}
      >
        <span>#</span>
      </th>
      {columns.map((col, index) => (
        <th
          key={`header-${index}`}
          style={{
            textAlign:
              col !== "Invoice Number" &&
                col !== "Sales Number" &&
                col !== "Customer Name" &&
                col !== "Start Date"
                ? "center"
                : "left",
          }}
        >
          {col}
        </th>
      ))}

      <th className="text-start " style={{ padding: "0px 2px" }} aria-sort="">
        Attachment
      </th>
      <th className="text-start " style={{ minWidth: '2 rem' }}></th>
    </tr>
  </thead>);

  const tableBody = () => (allSalesOrder.map((saleOrder, index) => (
    <tr key={saleOrder?.id || index}>
      <td>{offset * limit + index + 1}</td>

      {columns.map((col, cellIndex) => {
        switch (col) {
          case "Payment Number":
            return (
              <td key={`cell-${index}-${cellIndex}`}>
                {saleOrder.payment_number}
              </td>
            );

          case "Invoice Number":
            return (
              <td key={`cell-${index}-${cellIndex}`}>
                {saleOrder.invoice_number}
              </td>
            );

          case "Reference Number":
            return (
              <td key={`cell-${index}-${cellIndex}`}>
                {saleOrder.reference_number}
              </td>
            );

          case "Account Type":
            return (
              <td key={`cell-${index}-${cellIndex}`}>
                {saleOrder.account_name}
              </td>
            );

          case "Payment Mode":
            return (
              <td key={`cell-${index}-${cellIndex}`} style={{ textAlign: "center" }}>
                {saleOrder.payment_mode}
              </td>
            );

          case "Amount Received":
            return (
              <td key={`cell-${index}-${cellIndex}`} style={{ textAlign: "center" }}>
                {formatToINR(saleOrder.amount_recevied || 0)}
              </td>
            );

          case "Bank Charges":
            return (
              <td key={`cell-${index}-${cellIndex}`} style={{ textAlign: "center" }}>
                {formatToINR(saleOrder?.bank_charges || 0)}
              </td>
            );

          case "Payment Date":
            return (
              <td key={`cell-${index}-${cellIndex}`}>
                {formatDate(saleOrder?.payment_date)}
              </td>
            );

          case "Payment Received On":
            return (
              <td key={`cell-${index}-${cellIndex}`} style={{ textAlign: "center" }}>
                {formatDate(saleOrder?.payment_recieved_on)}
              </td>
            );

          case "Amount Deducted":
            return (
              <td key={`cell-${index}-${cellIndex}`} style={{ textAlign: "center" }}>
                {formatToINR(saleOrder?.amount_deducted || 0)}
              </td>
            );

          case "Tax Deducted":
            return (
              <td key={`cell-${index}-${cellIndex}`} style={{ textAlign: "center" }}>
                {saleOrder?.tax_deducted}
              </td>
            );

          case "TDS Tax Account":
            return (
              <td key={`cell-${index}-${cellIndex}`}>
                {saleOrder?.tds_tax_account || "-"}
              </td>
            );

          default:
            return null;
        }
      })}

      <td key={`attachment-${index}`} style={{ textAlign: "center" }}>
        {saleOrder.attachment ? (
          <a
            href={`${baseURL}${saleOrder.attachment}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none", color: "#007bff" }}
          >
            <FontAwesomeIcon
              style={{
                width: "18px",
                height: "18px",
                cursor: "pointer",
                color: "grey",
              }}
              icon={faFile}
            />
          </a>
        ) : (
          "-"
        )}
      </td>
      <td
        className="text-center "
        style={{ cursor: "pointer" }}
        onClick={() => {
          onDelete(saleOrder?.payment_id);
        }}
      >
        {" "}
        <FontAwesomeIcon
          className="text-danger"
          icon={faTrash}
        />
      </td>
    </tr>
  )));

  return (
    <>
      <DeleteModal
        show={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={handleConfirmedDelete}
        isLoading={loading}
        message={"Are you sure you want to permanently delete this payment?"}
      />
      <div className=" pb-1 d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center gap-2">
          <h3
            className="mb-0 d-flex gap-2 align-items-center"
            style={{
              whiteSpace: "nowrap",
              fontWeight: 300,
              fontSize: "22px",
              color: "#4dabf4",
            }}
          >
            Payment Received
          </h3>
        </div>

        <div
          className="d-flex align-items-center gap-1"
          style={{
            height: "39px",
            position: "absolute",
            right: 0,
            top: "0.5rem",
          }}
        >
          <div className=" position-relative">
            <input
              type="text"
              style={{
                fontSize: "12px",
                paddingLeft: "36px",
                height: "35px",
              }}
              className="form-control "
              value={inputSearch}
              onChange={(e) => {
                setInputSearch(e.target.value);
                setOffset(0);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  setSearch(inputSearch);
                  setOffset(0);
                }
              }}
            />
            <i
              className="fa-solid fa-magnifying-glass"
              style={{
                position: "absolute",
                marginTop: "-26px",
                zIndex: 1,
                marginLeft: "13px",
              }}
            ></i>
            {inputSearch.length > 0 && (
              <i
                className="fa-solid fa-xmark"
                style={{
                  position: "absolute",
                  marginTop: "-26px",
                  zIndex: 1,
                  right: 0,
                  marginRight: "13px",
                  cursor: "pointer",
                }}
                onClick={() => setInputSearch("")}
              ></i>
            )}
          </div>

          <ColumnConfigurator
            columnOptions={columnOptions}
            columns={columns}
            setColumns={setColumns}
            storageKey="payReceivedColumns"
            visibleKey="visiblePayReceivedColumns"
          />
        </div>
      </div>

      <Container
        fluid
        style={{
          fontFamily: "'Poppins', sans-serif",
          height: "calc(100vh - 14rem)",
          padding: 0,
          animation: "cardEntry 1s ease-out forwards",
        }}
        className="mt-3 p-0"
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            width: "100%",
            borderRadius: "7px"
          }}
          className='position-relative container-table '
        >
          <TableWrapper
            isLoading={isLoading}
            hasData={allSalesOrder?.length > 0}
            tableHeader={tableHeader()}
            tableBody={tableBody()}
            displayStartItem={displayStartItem}
            displayEndItem={displayEndItem}
            totalItems={totalItems}
            currPageItems={currPageItems}
            offset={offset}
            setOffset={setOffset}
            limit={limit}
            setLimit={setLimit}
            handlePageChange={handlePageChange}
            effectivePageCount={pageCount}
            columnLabels={columns}
          />
        </div >
      </Container >
    </>
  );
};
